/**
 * ====================== H5 SDK Auth Constants ======================
 *
 * Update các giá trị dưới đây để điều chỉnh hành vi SDK.
 * Tất cả delay time đều dùng đơn vị MILLISECONDS (1000ms = 1s)
 */

/**
 * Sau khi user ĐĂNG KÝ / ĐĂNG NHẬP / AUTO LOGIN (guest) lần đầu mà CHƯA xác thực SĐT:
 *   - Đợi hết khoảng thời gian này rồi mới BUỘC hiện popup "Xác thực số điện thoại".
 *   - TRƯỚC thời gian delay: user vào game BÌNH THƯỜNG, không bị chặn step này.
 *
 *  === MUỐN ĐỔI THỜI GIAN HIỆN STEP CONFIRM PHONE? CHỈNH SỐ DƯỚI ĐÂY ===
 *  Mẫu:
 *    5 phút   = 5  * 60 * 1000 = 300_000
 *    10 phút  = 10 * 60 * 1000 = 600_000   ← DEFAULT
 *    15 phút  = 15 * 60 * 1000 = 900_000
 *    30 phút  = 30 * 60 * 1000 = 1_800_000
 *    1 giờ    = 60 * 60 * 1000 = 3_600_000
 */
export const REQUIRE_VERIFY_PHONE_AFTER_LOGIN_DELAY_MS = 10 * 60 * 1000;

/**
 * LocalStorage key prefix để lưu:
 *   - Lần đăng ký/đăng nhập gần nhất (timestamp ms) của user
 *   ... theo user.id để không xung đột khi đổi account trên cùng thiết bị.
 */
export const LAST_LOGIN_TS_STORAGE_PREFIX = 'joygames:last-login-ts';

/**
 * User chủ động click ✕ tắt popup Verify SĐT → cool down 12 tiếng trước khi hỏi lại.
 * Mục đích: cho phép chơi game tiếp bình thường ngay, không làm phiền liên tục sau mỗi
 * F5 / mỗi lần App re-render (fix bug: click x → re-show ngay lập tức do useEffect re-run).
 * Key theo user.id để multi-account cùng máy độc lập nhau.
 */
export const DISMISS_VERIFY_PHONE_COOLDOWN_MS = 12 * 60 * 60 * 1000;
export const LAST_DISMISS_VERIFY_TS_STORAGE_PREFIX = 'joygames:last-dismiss-verify-phone-ts';

export const PAYMENT_GATEWAY = {
  ZALO: 'zalo',
  MOMO: 'momo',
  MOMO_PAY_LATER: 'momoPayLayter',
  PAY_OS: 'payOS',
  ONEPAY: 'onepay',
  BALANCE: 'balance',
  PAYER_MAX: 'payerMax',
  ZALO_PAY: 'zaloPay'
};

export const ORDER_STATUS = {
  PLACED: 'placed',
  PAID: 'paid',
  REFUNDED: 'refunded'
};

export const ORDER_TYPE = {
  IAP: 'iap',
  TOP_UP: 'top_up',
  TICKET: 'ticket',
  GIFT_CODE: 'gift_code'
};

export const CONVERSION_RATE = 0.01; // $1000 => 1 xu
export const DISCOUNT_RATE = 0.9;
